export const SET_DEACTIVE_REASON = "SET_DEACTIVE_REASON";

export function getDeactiveReasonSelected(data) {
    return function (dispatch) {
        dispatch({ type: SET_DEACTIVE_REASON, deactiveReason: data });
    };
}